import React, { useContext } from "react";
import useT from "../../hooks/useT";
import { APP_PAGE, actions } from "../../hooks/useAppState";
import { AppStateContext } from "../../containers/App";
import { CustomerPageContext } from "../../containers/CustomerPage";
import Button from "../Button";

export default function ConfirmLeaveCustomerPage() {
  // Shared context
  const { t } = useT();
  const [, doAppStateAction] = useContext(AppStateContext);
  const [customerPage, doCustomerPageAction] = useContext(CustomerPageContext);

  return (
    <div className="confirm-leave-customer-page">
      <h3 className="confirm-leave-title">
        {t("customer.confirmLeave.title", {
          lng: customerPage.language
        })}
      </h3>
      <div className="confirm-leave-intro">
        <p>
          {t("customer.confirmLeave.intro", {
            lng: customerPage.language
          })}
        </p>
      </div>
      <div className="button-group">
        <Button
          label={t("customer.confirmLeave.buttons.leave.label", {
            lng: customerPage.language
          })}
          shape="solid"
          theme="primary"
          fullWidth
          onClick={event => {
            event.preventDefault();
            doAppStateAction(actions.setPage(APP_PAGE.ACTIONS));
          }}
        />
        <Button
          label={t("customer.confirmLeave.buttons.remain.label", {
            lng: customerPage.language
          })}
          shape="default"
          fullWidth
          onClick={event => {
            event.preventDefault();
            doCustomerPageAction({
              action: "toggleModal",
              payload: {
                name: "confirmLeave",
                display: false
              }
            });
          }}
        />
      </div>
    </div>
  );
}
